import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

const { devices, fontSizes, colors, spaces } = theme;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledStep = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  padding: ${spaces.large7X - 2}px ${spaces.large2X - 2}px;
  background: linear-gradient(
    180deg,
    ${colors.blue[50]} 0%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 30px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
  width: 100%;
  height: 100%;

  @media ${devices.tablet} {
    padding-top: ${spaces.large2X}px;
    padding-bottom: ${spaces.large2X}px;
    padding-left: ${spaces.large}px;
    padding-right: ${spaces.large}px;
  }
`;
const StyledStepIconContainer = styled.div`
  margin-top: ${spaces.large2X - 2}px;
  margin-bottom: ${spaces.large2X - 2}px;
  margin-left: ${spaces.large10X}px;
  margin-right: ${spaces.large10X}px;

  svg {
    height: 180px;
    width: 180px;
  }

  img {
    min-height: 180px;
  }

  @media ${devices.tablet} {
    margin-left: auto;
    margin-right: auto;
  }
`;
const StyledTop = styled.div`
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.regular}px;
  line-height: 130%;
  text-align: center;
  color: ${colors.blue[600]};
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;
const StyledBottom = styled.div`
  flex-grow: 1;

  .header {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.large2X}px;
    line-height: 150%;
    text-align: center;
    color: ${colors.gray[800]};
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }
  .description {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 400;
    font-size: ${fontSizes.large}px;
    line-height: 150%;
    text-align: center;
    color: ${colors.gray[700]};
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
  }
`;
const Step = ({ imgSrc, top, bottom }) => {
  return (
    <StyledStep>
      <StyledTop>{top}</StyledTop>
      {imgSrc && (
        <StyledStepIconContainer>
          <picture>
            <source srcSet={imgSrc} type="image/png" />
            <img src={imgSrc} alt="Banner image" />
          </picture>
        </StyledStepIconContainer>
      )}
      <StyledBottom>{bottom}</StyledBottom>
    </StyledStep>
  );
};

export default Step;
